import type { McpServer } from "@/app/mcp-gateways/types";
import type { Jtbd } from "@/app/onboarding-first-win/api/get-jtbds";
import type { OnboardingGateway } from "../api/get-onboarding-progress";

/** Mirror experience-api shapes for optimistic cache updates. */

function getServicesFromTools(tools: string[]): string[] {
  const services = tools
    .map((tool) => tool.split(".")[0]?.trim())
    .filter((service): service is string => Boolean(service));
  return Array.from(new Set(services));
}

export function mapMcpServerToOnboardingGateway(
  server: Pick<McpServer, "id" | "name" | "slug" | "auth_type" | "tool_filter">,
  jtbds: Jtbd[] = []
): OnboardingGateway {
  const allowed_tools = server.tool_filter?.allowed_tools ?? [];
  const jtbd = jtbds.find((entry) => entry.name === server.name) ?? null;
  const services = getServicesFromTools(
    allowed_tools.length > 0 ? allowed_tools : (jtbd?.tools ?? [])
  );

  return {
    id: server.id,
    name: server.name,
    slug: server.slug,
    auth_type: server.auth_type,
    allowed_tools,
    jtbd,
    services,
  };
}
